import { CardsProps, ExpandableSection } from '@cloudscape-design/components';
import { SDKDocSearchResult } from '../../../../common/types/interfaces';
import { SpaceBetween } from '@cloudscape-design/components';
import { SDKDocElement, SDKDocResultHeader, SDKInputArgs, SDKOutput, SDKInstance } from '../components/SDKDocComponents';

export const CARD_DEFINITIONS: CardsProps.CardDefinition<SDKDocSearchResult> = {
  header: (item) => (
    <ExpandableSection
      defaultExpanded={item.isTopResult}
      variant="container"
      header={<SDKDocResultHeader sdkDocItem={item} />}
    >
      <SpaceBetween size="m">
        <SDKDocElement header="Description" value={item.content.description} />
        <SDKInstance sdkDocItem={item} />
        <SDKInputArgs sdkDocItem={item} />
        <SDKOutput sdkDocItem={item} />
      </SpaceBetween>
    </ExpandableSection>
  ),
};
